import { useState, useContext } from "react";
import { DataContext, DataContextContractual } from "../../../contextData/contextData";
import { Celda, CeldaHeader, useSolicitudesCurso } from "../../solicitudes-en-curso/useSolicitudesCurso";
import { obtenerDatosTemporisApi } from "../../../api/listas/temporisApi";
import { faEye } from "@fortawesome/free-solid-svg-icons";
// import { modalEjecutar } from "../../../components/ui/sweetAlerts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { CambioCargo } from "../../cambio-de-cargo/CambioCargo";
import { formatFecha } from "../../../utils/funciones";
import { useIndex } from "../../useIndex";
import { useFormik } from "formik";
import moment from "moment";
import { ModalBody } from "../../solicitudes-en-curso/modalBody";

const estilo = {
  display: 'flex', justifyContent: 'center'
}


// const returnAccesos = perfil => {
//   const obj = {
//     "4": [], // perfil 4 (administrador) accede solo cuando esta en estado inicial (1)
//     "2": [], // perfil 2 (jefe zona) accede solo ya aprobo el admin de destino (10)
//     "3": [2, 4], // perfil 3 (rrhh) ve botones cuando esta aprobado por jefe de zona (  2) o aprobado por mismo rrhh (4)
//   }
//   return obj[perfil];
// }

// const returnAccesosBtnVer = (perfil, row) => {
//   const obj = {
//     "4": [1, 7, 10, 11], // perfil 4 (administrador) accede solo cuando esta en estado inicial (1)
//     "2": [6, 7, 10, 11], // perfil 2 (jefe zona) accede solo ya aprobo el admin de destino (10)
//     "3": [2, 4, 10], // perfil 3 (rrhh) ve botones cuando esta aprobado por jefe de zona (  2) o aprobado por mismo rrhh (4)
//   }

//   if ([10].includes(row.id_estado_solicitud) && !["3"].includes(perfil)) {
//     return []
//   }

//   return obj[perfil];
// }

// const visibleBtns = (estado) => {
//   const obj = {
//     "4": [1, 7, 10], // perfil 4 (administrador) accede solo cuando esta en estado inicial (1)
//     "2": [6, 11], // perfil 2 (jefe zona) accede solo ya aprobo el admin de destino (10)
//     "3": [2, 4, 10], // perfil 3 (rrhh) ve botones cuando esta aprobado por jefe de zona (  2) o aprobado por mismo rrhh (4)
//   }

//   return obj[localStorage.getItem("id_perfil")].includes(estado) ? true : false;
// }


// const visibleBtns_2 = (estado) => {
//   const obj = {
//     "4": [1, 7, 10], // perfil 4 (administrador) accede solo cuando esta en estado inicial (1)
//     "2": [6, 11], // perfil 2 (jefe zona) accede solo ya aprobo el admin de destino (10)
//     "3": [2, 4, 10], // perfil 3 (rrhh) ve botones cuando esta aprobado por jefe de zona (  2) o aprobado por mismo rrhh (4)
//   }

//   const vaina = obj[localStorage.getItem("id_perfil")].includes(estado);
//   return vaina;
// }

export const useSolicitudesPendientes = () => {
  const { visible, hideModal, returnAccesos } = useSolicitudesCurso();
  const { diasAnticipo } = useContext(DataContextContractual);
  const [arrTemporis, setArrTemporis] = useState([]);
  const [arrPlanHorario, setArrPlanHorario] = useState([]);
  const [tamanioModal, setTamanioModal] = useState("xl");
  const { objTipoContrato } = useIndex();
  const [objDataModal, setObjDataModal] = useState({
    titulo: "Cambio de instalación",
    component: (
      <div>-- Componente de prueba --</div>
    ),
  });



  const getTemporis = async (local_codigo_erp, numero_plan_horario) => {
    const temporis = await obtenerDatosTemporisApi(local_codigo_erp, numero_plan_horario);
    setArrPlanHorario(temporis.data);

    const arr = temporis.data_temporis.map((el) => {
      return {
        label: `${el.Unidadorganizativa} - ${el.Cargogenericonombre}`,
        value: el,
      };
    });

    setArrTemporis(arr);
  }

  const validate = (obj) => {
    let errObj = {};

    if (!["01"].includes(obj.fecha_inicio_cambio.split("-")[2])) errObj.fecha_inicio_cambio = 'Solo primer día (01) de cada mes';
    if (
      moment(formik.values.fecha_inicio_cambio).diff(moment(new Date()).subtract(diasAnticipo, "d"), "days")
      <
      moment(formik.values.fecha_inicio_cambio).diff(moment(formik.values.fecha_inicio_cambio).subtract(diasAnticipo, "d"), "days")
    ) {
      errObj.fecha_inicio_cambio = 'Fecha fuera de rango. Validar con Remuneraciones.';
    }

    if (!obj.cod_sap_nuevo_cargo) errObj.cod_sap_nuevo_cargo = 'Requerido';
    if (!obj.nueva_unidad_organizativa) errObj.nueva_unidad_organizativa = 'Requerido';
    if (!obj.nuevo_plan_horario) errObj.nuevo_plan_horario = 'Requerido';
    // }

    return errObj;
  }

  const formik = useFormik({
    initialValues: {
      fecha_inicio_cambio: '',
      cod_sap_nuevo_cargo: '',
      nueva_unidad_organizativa: '',
      nuevo_plan_horario: '',
    },
    validate,
  });

  const arrColumnas = [
    {
      name: "Colaborador",
      cell: row => <Celda label={row.persona.nombre + " " + row.persona.apellido_pat + " " + row.persona.apellido_mat} ancho="300px" />,
      width: "300px"
    },
    {
      name: <CeldaHeader label="RUT" alineacion="center" />,
      selector: row => row.persona.identificacion,
      style: estilo,
      width: "90px"
    },
    {
      name: <CeldaHeader label="Nro. Personal" alineacion="center" />,
      selector: row => row.persona.id_sap,
      style: estilo,
      width: "110px"
    },
    {
      name: "Instalación de origen",
      selector: row => row.instalacion_actual,
      width: "240px"
    },
    {
      name: "Cargo actual",
      cell: row => <Celda label={row.nombre_cargo_actual ? row.nombre_cargo_actual.split('|')[1] : "---"} ancho="240px" />,
      style: estilo,
      width: "240px"
    },
    {
      name: <CeldaHeader label="Fecha inicio cambio" alineacion="center" />,
      selector: row => row.fecha_inicio_cambio ? formatFecha(row.fecha_inicio_cambio.replace(/-/g, '')) : "---",
      style: estilo,
      width: "150px"
    },
    {
      name: <CeldaHeader label="Tipo contrato" alineacion="center" />,
      selector: row => objTipoContrato[row.persona.tipo_contrato] ?? "---",
      style: estilo,
      width: "110px"
    },
    {
      name: "Estado actual",
      cell: row => <Celda label={row.estado_solicitud_cambio_contractual.nombre} ancho="300px" />,
      width: '300px'
    },
    {
      name: <CeldaHeader label="Acciones" alineacion="center" />,
      width: "100px",
      button: true,
      cell: (row) => {
        return (
          <button
            className={`btn gap-2 d-flex align-items-center py-0 btn-${returnAccesos(localStorage.getItem("id_perfil"), row.id_tipo_solicitud, row.id_estado_solicitud) === false ? "outline-secondary" : "primary"} btn-sm`}
            data-bs-toggle="tooltip" title="Ver solicitud"
            onClick={() => {
              setTamanioModal("xl");
              hideModal(row);
              setObjDataModal({ ...objDataModal, component: <ModalBody visibleBtns={returnAccesos(localStorage.getItem("id_perfil"), row.id_tipo_solicitud, row.id_estado_solicitud)} obj={row} /> })
            }}
          >
            VER <FontAwesomeIcon icon={faEye} title='Ver solicitud' />
          </button>
        )
      },
    },
  ]


  return { arrColumnas, visible, hideModal, validate, formik, arrTemporis, arrPlanHorario, getTemporis, objDataModal, tamanioModal }
}